import { inspect } from 'node:util';
import { ExtendableError } from 'ts-error';
import { addErrorParser, chainError, } from '@cbbt/lib-error-parser';
import { TRANSPORT } from '../service/enums.js';
import ServiceErrorDescriptor from './ServiceErrorDescriptor.js';
class ServiceError extends ExtendableError {
    response;
    code;
    status;
    details;
    errorCode;
    logData;
    causedBy;
    constructor(...args) {
        super();
        const payload = args[0];
        const { code, status, message = '', responseClass, } = ServiceErrorDescriptor.load(this);
        if (!code) {
            console.error(`Error ${this.name} has not been registered using RegisterServiceError`);
        }
        this.code = code;
        this.status = status;
        this.message = message;
        this.causedBy = [];
        if (responseClass && this.isPayloadWithResponse(payload)) {
            if (responseClass.isInstance(payload.response)) {
                this.response = payload.response;
            }
            else {
                this.response = responseClass.create(payload.response);
            }
        }
        this.details = payload?.details;
        this.errorCode = payload?.errorCode;
        this.logData = payload?.logData;
        if (payload?.error) {
            chainError(this, payload.error);
        }
    }
    isPayloadWithResponse(payload) {
        return Boolean(payload?.response);
    }
    toJSON(target) {
        const errorJson = {
            code: this.code,
            message: this.message,
            details: this.details,
            errorCode: this.errorCode,
            response: this.response?.toJSON(target),
        };
        if (target === TRANSPORT.GRPC) {
            return errorJson;
        }
        return {
            errors: [errorJson],
        };
    }
    inspect(options = {}) {
        return inspect(this, {
            colors: true,
            depth: Infinity,
            getters: true,
            ...options,
        });
    }
}
const serviceErrorParser = (error) => {
    if (error instanceof ServiceError) {
        return {
            code: error.code,
            causedBy: error.causedBy,
            ...(error.details && { details: error.details }),
            ...(error.errorCode && { errorCode: error.errorCode }),
            ...(error.logData && { logData: error.logData }),
        };
    }
    return undefined;
};
addErrorParser(serviceErrorParser);
export default ServiceError;
//# sourceMappingURL=ServiceError.js.map